import React, { useState } from 'react';
import KategorieTable from './UstawieniaMagazynu/ListaKategorii';
import JednostkiTable from './UstawieniaMagazynu/ListaJednostek';
import StawkiVatTable from './UstawieniaMagazynu/ListaStawekVat';
import './componenetStyle/ListaUrzadzen.css';

const UstawieniaMagazynu = () => {
  const [tab, setTab] = useState('kategorie'); // 'kategorie' | 'jednostki' | 'vat'

  return (
    <div style={{ padding: 16 }}>
      <div className="header" style={{ gap: 8 }}>
        <h2>Ustawienia magazynu</h2>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
          <button className={`add-button ${tab === 'kategorie' ? 'active' : ''}`} onClick={() => setTab('kategorie')}>Kategorie</button>
          <button className={`add-button ${tab === 'jednostki' ? 'active' : ''}`} onClick={() => setTab('jednostki')}>Jednostki miary</button>
          <button className={`add-button ${tab === 'vat' ? 'active' : ''}`} onClick={() => setTab('vat')}>Stawki VAT</button>
        </div>
      </div>

      {tab === 'kategorie' && <KategorieTable />}
      {tab === 'jednostki' && <JednostkiTable />}
      {tab === 'vat' && <StawkiVatTable />}
    </div>
  );
};

export default UstawieniaMagazynu;
